import {
    Box,
    Button,
    Chip,
    Container,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    makeStyles,
    Tab,
    Tabs,
    Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import CriticNav from "../CriticNav/CriticNav";
import demo from "../../icons/default1.png";
import { ArrowDownward, KeyboardArrowDown, Timer } from "@material-ui/icons";
import config from "../../config/apiConfig";
import Cookies from "js-cookie";
import { Story } from "../StoryCardSmall/StoryCardSmall";

const requestOptions = {
    method: "POST",
    body: null,
    headers: {
        "Access-Control-Allow-Origin": "*",
        session_token: Cookies.get("token") ?? "",
        token: config.token,
    },
};

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(14),
        paddingBottom: theme.spacing(5),
    },
    flexBox: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        padding: theme.spacing(2),
        "& div": {
            textAlign: "center",
        },
        "& h6": {
            fontWeigth: "bold",
        },
        "& p": {
            color: theme.palette.text.secondary,
        },
    },
    timer: {
        background: "#fff2f5",
        color: config.primary_color,
        "& svg": {
            color: config.primary_color,
        },
    },
}));

type ReviewCount = {
    reviewedStories: number;
    underReviewStories: number;
    totalStories: number;
};

type Revenue = {
    fromSales: number;
    fromReview: number;
    totalAmount: number;
};

type StoriesStatus = {
    inMarketPlace: number;
    buy: number;
    shortList: number;
};

const CriticDash: React.FC = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [reviewCount, setReviewCount] = React.useState<ReviewCount>({
        reviewedStories: 0,
        underReviewStories: 0,
        totalStories: 0,
    });
    const [revenue, setRevenue] = React.useState<Revenue>({
        fromSales: 0,
        fromReview: 0,
        totalAmount: 0,
    });
    const [storiesStatus, setStoriesStatus] = React.useState<StoriesStatus>({
        inMarketPlace: 0,
        buy: 0,
        shortList: 0,
    });
    const [selected, setSelected] = React.useState<"reviewed" | "underReview">(
        "reviewed"
    );
    const [stories, setStories] = React.useState<Story[]>([]);

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            try {
                const promise1 = fetch(
                    config.BASE_URL + "/v2/api/critics/review/status",
                    requestOptions
                )
                    .then((res) => res.json())
                    .then((response) => {
                        if (mounted) {
                            setReviewCount(response);
                        }
                    });

                const promise2 = fetch(
                    config.BASE_URL + "/v2/api/critics/revenue/get",
                    requestOptions
                )
                    .then((res) => res.json())
                    .then((response) => {
                        if (mounted) {
                            setRevenue(response);
                        }
                    });

                const promise3 = fetch(
                    config.BASE_URL + "/v2/api/critics/stories/status",
                    requestOptions
                )
                    .then((res) => res.json())
                    .then((response) => {
                        if (mounted) {
                            setStoriesStatus(response);
                        }
                    });

                await Promise.all([promise1, promise2, promise3]);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        let mounted = true;
        setStories([]);

        const fetchData = async () => {
            try {
                const response = await fetch(
                    config.BASE_URL + "/v2/api/critics/review/" + selected,
                    requestOptions
                ).then((res) => res.json());
                if (mounted) {
                    setStories(response);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();

        return () => {
            mounted = false;
        };
    }, [selected]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <React.Fragment>
            <CriticNav />
            <Container className={classes.root} maxWidth="lg">
                <Grid container spacing={4}>
                    <Grid item md={8} sm={12} xs={12}>
                        <Typography variant="h4">
                            All Stories and Scripts
                        </Typography>
                        <Box borderBottom="1px solid #e0e0e0" my={2}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                            >
                                <Tab label="Stories" />
                                <Tab label="Scripts" />
                            </Tabs>
                        </Box>
                        <Box className={classes.flexBox} bgcolor="#f7f7f7">
                            <div>
                                <Typography variant="h5">
                                    {reviewCount.totalStories}
                                </Typography>
                                <Typography variant="body1" component="p">
                                    Total Stories
                                </Typography>
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div>
                                <Typography variant="h5">
                                    {reviewCount.reviewedStories}
                                </Typography>
                                <Typography variant="body1" component="p">
                                    Stories Reviewed
                                </Typography>
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div>
                                <Typography variant="h5">
                                    {reviewCount.underReviewStories}
                                </Typography>
                                <Typography variant="body1" component="p">
                                    Pending for Review
                                </Typography>
                            </div>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item md={4} sm={12} xs={12}>
                                <Box pt={2} />
                                <Button
                                    variant="contained"
                                    color={
                                        selected === "underReview"
                                            ? "secondary"
                                            : "default"
                                    }
                                    fullWidth
                                    onClick={() => setSelected("underReview")}
                                >
                                    Pending for Review
                                </Button>
                                <Box height={8} />
                                <Button
                                    variant="contained"
                                    color={
                                        selected === "reviewed"
                                            ? "secondary"
                                            : "default"
                                    }
                                    fullWidth
                                    onClick={() => setSelected("reviewed")}
                                >
                                    Reviewed
                                </Button>
                            </Grid>
                            <Grid item md={8} sm={12} xs={12}>
                                <List style={{ width: "100%", paddingTop: 0 }}>
                                    {stories.map((item) => (
                                        <React.Fragment>
                                            <ListItem
                                                key={item.storyId}
                                                alignItems="flex-start"
                                            >
                                                <ListItemAvatar
                                                    style={{ marginRight: 16 }}
                                                >
                                                    <img src={demo} alt="" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={
                                                        <Box
                                                            display="flex"
                                                            justifyContent="space-between"
                                                        >
                                                            <div>
                                                                <Typography variant="h5">
                                                                    My Lockdown
                                                                    Love
                                                                </Typography>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    color="textSecondary"
                                                                >
                                                                    by Pooja
                                                                    Gupta
                                                                </Typography>
                                                            </div>
                                                            <Chip
                                                                className={
                                                                    classes.timer
                                                                }
                                                                icon={
                                                                    <Timer fontSize="small" />
                                                                }
                                                                label="1 day left"
                                                            />
                                                        </Box>
                                                    }
                                                    secondary={
                                                        <Box py={1}>
                                                            <Chip label="5 parts" />
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    margin: "8px 0",
                                                                }}
                                                            >
                                                                Board hanging at
                                                                the gate of
                                                                Nakshatra Villa,
                                                                gated community
                                                                in Shamshabad on
                                                                Sunday where the
                                                                veterinarian g…
                                                            </Typography>
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                            >
                                                                Review
                                                            </Button>
                                                        </Box>
                                                    }
                                                />
                                            </ListItem>
                                            <Divider component="li" />
                                        </React.Fragment>
                                    ))}
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12}>
                        <Box className={classes.flexBox} mb={2}>
                            <div>
                                <Typography variant="h5">{storiesStatus.inMarketPlace}</Typography>
                                <Typography variant="body1" component="p">
                                    Marketplace
                                </Typography>
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div>
                                <Typography variant="h5">{storiesStatus.shortList}</Typography>
                                <Typography variant="body1" component="p">
                                    Shortlisted
                                </Typography>
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div>
                                <Typography variant="h5">{storiesStatus.buy}</Typography>
                                <Typography variant="body1" component="p">
                                    Buy
                                </Typography>
                            </div>
                        </Box>
                        <Box border="1px solid #e0e0e0" borderRadius={8} p={2}>
                            <Typography
                                variant="h6"
                                color="textSecondary"
                                gutterBottom
                            >
                                Your Overall Revenue
                            </Typography>
                            <Divider />
                            <Box py={3} textAlign="center">
                                <Typography variant="h3">₹{revenue.totalAmount}k</Typography>
                                <Typography
                                    variant="subtitle1"
                                    color="textSecondary"
                                >
                                    Revenue
                                </Typography>
                                <List style={{ width: "100%" }}>
                                    <ListItem>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            border="1px solid #e0e0e0"
                                            borderRadius={8}
                                            width="100%"
                                            p={2}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                color="textSecondary"
                                            >
                                                ₹{revenue.fromSales}k from stories sales
                                            </Typography>
                                            <KeyboardArrowDown />
                                        </Box>
                                    </ListItem>
                                    <ListItem>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            border="1px solid #e0e0e0"
                                            borderRadius={8}
                                            width="100%"
                                            p={2}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                color="textSecondary"
                                            >
                                                ₹{revenue.fromReview}k from stories reviewed
                                            </Typography>
                                            <KeyboardArrowDown />
                                        </Box>
                                    </ListItem>
                                </List>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
};

export default CriticDash;
